import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'shared-chat-timestamp',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './chat-timestamp.component.html',
  styleUrl: './chat-timestamp.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatTimestampComponent {
  time = input.required<string>();
}
